import { useRouteMatch } from 'react-router-dom';
import { Flex } from '@theme-ui/components';

import { getStoredCartIsVirtual } from '@app/pages/Cart/Cart';
import { rem } from '@app/styles/theme/layout';

import Step from './Step';
import messages from './StepsProgress.messages';
import type { StepState } from './StepsProgress.types';

const ALL_STEPS = {
  address: {
    title: messages.address,
    route: '/:language/shop/checkout/address/',
  },
  delivery: {
    title: messages.shipping,
    route: '/:language/shop/checkout/delivery/',
  },
  review: {
    title: messages.review,
    route: '/:language/shop/checkout/review/',
  },
  payment: {
    title: messages.payment,
    route: '/:language/shop/checkout/payment/:status?/',
  },
};

const stepsVirtual = [ALL_STEPS.address, ALL_STEPS.review, ALL_STEPS.payment];

const stepsHardware = [
  ALL_STEPS.address,
  ALL_STEPS.delivery,
  ALL_STEPS.review,
  ALL_STEPS.payment,
];

const Steps = ({ isVirtual }: { isVirtual?: boolean }) => {
  const { path } = useRouteMatch();
  const steps = isVirtual ? stepsVirtual : stepsHardware;
  const currentStepIndex = steps.findIndex(({ route }) => route === path);

  return (
    <Flex p={3} sx={{ flex: 1, alignItems: 'center', maxWidth: rem(600) }}>
      {steps.map((step, index) => {
        const stepState: StepState = {
          step,
          stepNumber: index + 1,
          isActive: currentStepIndex === index,
          isPassed: currentStepIndex > index,
          isLast: steps.length - 1 === index,
        };

        return <Step key={step.route} stepState={stepState} />;
      })}
    </Flex>
  );
};

const StepsProgress = () => {
  const isVirtual = getStoredCartIsVirtual();

  return (
    <Flex
      sx={{ justifyContent: 'center' }}
      pb={rem(14)}
      bg="white"
      css={{ borderBottom: `${rem(2)} solid rgba(0, 0, 0, 0.1)` }}
    >
      <Steps isVirtual={isVirtual} />
    </Flex>
  );
};

export default StepsProgress;
